import { ChangeEvent, ReactNode } from "react";
import { Checkbox, CheckboxSize } from "shared/components";

export const SourceCheckbox = ({
  label,
  icon,
  badge,
  checked,
  disabled,
  onChange
}: {
  label: string;
  icon?: ReactNode;
  badge?: ReactNode;
  checked: boolean;
  disabled?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}) => (
  <Checkbox
    size={CheckboxSize.BASE}
    width="auto"
    wrapperClassName="flex w-fit cursor-pointer"
    checked={checked}
    disabled={disabled}
    onChange={onChange}
    label={
      <span className="inline-flex items-center gap-3">
        {icon ? (
          <span className="inline-flex size-5 shrink-0 items-center justify-center [&>*]:!size-5 [&>img]:object-contain [&>svg]:size-5">
            {icon}
          </span>
        ) : null}
        {label}
        {badge}
      </span>
    }
  />
);
